// ===================== Seedable PRNG (mulberry32) =====================
export class RNG {
  constructor(seed = 123456789) {
    this.s = seed >>> 0;
  }
  // float in [0,1)
  next() {
    this.s |= 0;
    this.s = (this.s + 0x6d2b79f5) | 0;
    let t = Math.imul(this.s ^ (this.s >>> 15), 1 | this.s);
    t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  }
  // float in [lo, hi)
  range(lo, hi) { return lo + (hi - lo) * this.next(); }
  // int in [lo, hi]
  int(lo, hi) { return Math.floor(this.range(lo, hi + 1)); }
  // returns true with probability p
  chance(p) { return this.next() < p; }
  // random element of arr
  pick(arr) { return arr[Math.floor(this.next() * arr.length)]; }
  // random angle
  angle() { return this.next() * Math.PI * 2; }
  // shuffle in place (Fisher-Yates)
  shuffle(arr) {
    for (let i = arr.length - 1; i > 0; i--) {
      const j = Math.floor(this.next() * (i + 1));
      [arr[i], arr[j]] = [arr[j], arr[i]];
    }
    return arr;
  }
  // weighted pick: items:[{...}], weightFn -> number
  weighted(items, weightFn) {
    let total = 0;
    for (const it of items) total += Math.max(0, weightFn(it));
    if (total <= 0) return this.pick(items);
    let r = this.next() * total;
    for (const it of items) {
      r -= Math.max(0, weightFn(it));
      if (r <= 0) return it;
    }
    return items[items.length - 1];
  }
}
